// extracted by mini-css-extract-plugin
module.exports = {"analyticsBtn":"AnalyticsButton_analyticsBtn__35FX1","analyticsIcon":"AnalyticsButton_analyticsIcon__8CDeK"};